/**
 * Film Grid Component
 */

import { useState, useEffect } from '@wordpress/element';
import { useFilms } from '../context/FilmContext';
import FilmCard from './FilmCard';
import TrailerModal from './TrailerModal';

export default function FilmGrid({ genre, night, year, perPage = 12 }) {
    const { fetchFilms, films, loading, error } = useFilms();
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [trailerFilm, setTrailerFilm] = useState(null);
    const [isTrailerOpen, setIsTrailerOpen] = useState(false);

    useEffect(() => {
        loadFilms();
    }, [genre, night, year, page]);

    const loadFilms = async () => {
        const params = {
            page,
            per_page: parseInt(perPage),
        };

        if (genre) params.genre = genre;
        if (night) params.night = night;
        if (year) params.year = year;

        const result = await fetchFilms(params);
        setTotalPages(result.total_pages || 1);
    };

    const handleTrailerClick = (film) => {
        setTrailerFilm(film);
        setIsTrailerOpen(true);
    };

    const handleTrailerClose = () => {
        setIsTrailerOpen(false);
        setTrailerFilm(null);
    };

    if (loading && films.length === 0) {
        return (
            <div className="rialto-loading">
                <div className="rialto-spinner"></div>
            </div>
        );
    }

    if (error) {
        return <div className="rialto-error">{error}</div>;
    }

    const t = window.rialtoData?.translations || {};

    return (
        <div className="rialto-films-container">
            {films.length > 0 ? (
                <>
                    <div className="rialto-film-grid">
                        {films.map((film) => (
                            <FilmCard
                                key={film.id}
                                film={film}
                                onTrailerClick={handleTrailerClick}
                            />
                        ))}
                    </div>

                    {totalPages > 1 && (
                        <div className="rialto-pagination">
                            <button
                                className="rialto-btn rialto-btn-secondary"
                                disabled={page <= 1}
                                onClick={() => setPage(p => Math.max(1, p - 1))}
                            >
                                &larr; Previous
                            </button>
                            <span className="rialto-pagination-info">
                                Page {page} of {totalPages}
                            </span>
                            <button
                                className="rialto-btn rialto-btn-secondary"
                                disabled={page >= totalPages}
                                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                            >
                                Next &rarr;
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <p className="rialto-no-results">{t.noResults || 'No films found.'}</p>
            )}

            <TrailerModal
                film={trailerFilm}
                isOpen={isTrailerOpen}
                onClose={handleTrailerClose}
            />
        </div>
    );
}
